import dynamic from 'next/dynamic';

import { breakUpLongTask } from '@/utils/breakUpLongTasks/breakUpLongTasks';

export const componentMap = {
	Accordions: dynamic(breakUpLongTask(() => import('@/components/Accordions'))),
	AgendaStepper: dynamic(breakUpLongTask(() => import('@/components/AgendaStepper'))),
	BirdEyeReviews: dynamic(breakUpLongTask(() => import('@/components/BirdEyeReviews'))),
	CategoryPicker: dynamic(breakUpLongTask(() => import('@/components/CategoryPicker/CategoryPicker'))),
	Columns: dynamic(breakUpLongTask(() => import('@/components/Columns'))),
	ConvertFlowQuiz: dynamic(breakUpLongTask(() => import('@/components/ConvertFlowQuiz'))),
	ContentTypeRichText: dynamic(breakUpLongTask(() => import('@/components/ContentTypeRichText'))),
	DisclaimerV2: dynamic(breakUpLongTask(() => import('@/components/Disclaimer'))),
	ExperimentContainer: dynamic(breakUpLongTask(() => import('@/components/ExperimentContainer'))),
	Footer: dynamic(breakUpLongTask(() => import('@/components/Footer'))),
	GoogleMapTemplate: dynamic(breakUpLongTask(() => import('@/components/GoogleMap'))),
	HalfScreen: dynamic(breakUpLongTask(() => import('@/components/HalfScreen'))),
	Header: dynamic(breakUpLongTask(() => import('@/components/Header'))),
	HeroV2: dynamic(breakUpLongTask(() => import('@/components/Hero'))),
	Iframe: dynamic(breakUpLongTask(() => import('@/components/Iframe'))),
	Insurance: dynamic(breakUpLongTask(() => import('@/components/Insurance'))),
	MeetOurStaff: dynamic(breakUpLongTask(() => import('@/components/MeetOurStaff/MeetOurStaff'))),
	MultiCardV2: dynamic(breakUpLongTask(() => import('@/components/MultiCard'))),
	PatientReviewsV2: dynamic(breakUpLongTask(() => import('@/components/PatientReviews'))),
	QuickLinks: dynamic(breakUpLongTask(() => import('@/components/QuickLinks/QuickLinks'))),
	Schema: dynamic(breakUpLongTask(() => import('@/components/Schema/Schema'))),
	Service: dynamic(breakUpLongTask(() => import('@/components/Service/Service'))),
	ServiceLineHero: dynamic(breakUpLongTask(() => import('@/components/ServiceLineHero'))),
	SegmentsContainer: dynamic(breakUpLongTask(() => import('@/components/SegmentsContainer'))),
	SingleMessage: dynamic(breakUpLongTask(() => import('@/components/SingleMessage'))),
	SmileAssessmentForm: dynamic(breakUpLongTask(() => import('@/components/SmileAssessmentForm'))),
	Spacer: dynamic(breakUpLongTask(() => import('@/components/Spacer'))),
	Table: dynamic(breakUpLongTask(() => import('@/components/Table'))),
	TermsAndConditions: dynamic(breakUpLongTask(() => import('@/components/TermsAndConditions'))),
	TextBlockSeo: dynamic(breakUpLongTask(() => import('@/components/TextBlockSEO'))),
	LinkForwarder: dynamic(breakUpLongTask(() => import('@/components/LinkForwarder/LinkForwarder'))),
	OdpHero: dynamic(breakUpLongTask(() => import('@/components/Hero/ODP/ODPHero'))),
	BlogDetailsPage: dynamic(breakUpLongTask(() => import('@/components/BlogDetailsPage'))),
	ProductFeature: dynamic(breakUpLongTask(() => import('@/components/ProductFeature/ProductFeature'))),
	BlogListPage: dynamic(breakUpLongTask(() => import('@/components/BlogListPage'))),
	BlogList: dynamic(breakUpLongTask(() => import('@/components/BlogList'))),
	StateLinks: dynamic(breakUpLongTask(() => import('@/components/Centers/StateLinks/StateLinks'))),
	CityLinks: dynamic(breakUpLongTask(() => import('@/components/Centers/CityLinks/CityLinks'))),
	VideoCarousel: dynamic(breakUpLongTask(() => import('@/components/VideoCarousel'))),
	Tabs: dynamic(breakUpLongTask(() => import('@/components/Tabs'))),
	Marquee: dynamic(breakUpLongTask(() => import('@/components/Marquee/Marquee'))),
	Quiz: dynamic(breakUpLongTask(() => import('@/components/Quiz/Quiz'))),
	ProductDisplay: dynamic(breakUpLongTask(() => import('@/components/ProductPricing'))),
	Banner: dynamic(breakUpLongTask(() => import('@/components/Banner/Banner'))),
	Teletriage: dynamic(breakUpLongTask(() => import('@/components/Teletriage'))),
	SchedulingWidget: dynamic(breakUpLongTask(() => import('@/components/SchedulingWidget'))),
};

const teamTagComponents = {
	...componentMap, // Make sure componentMap is accessible here
	HeroV2: dynamic(breakUpLongTask(() => import('@/snowflakes/teamtag/Hero'))),
	// Now, MultiCardV2 always imports the unified loader component.
	// The conditional logic is moved *inside* MultiCardV2Loader.
	MultiCardV2: dynamic(breakUpLongTask(() => import('@/snowflakes/teamtag/MultiCard'))), // Import the new index.tsx
	ServiceLineHero: dynamic(breakUpLongTask(() => import('@/snowflakes/teamtag/ServiceLineHero/ServiceLineHero'))),
	BlogList: dynamic(breakUpLongTask(() => import('@/snowflakes/teamtag/BlogList'))),
	HalfScreen: dynamic(breakUpLongTask(() => import('@/snowflakes/teamtag/HalfScreen'))),
};

const AspenDentalComponents = {
	...componentMap, // Make sure componentMap is accessible here
	HeroV2: dynamic(breakUpLongTask(() => import('@/snowflakes/aspendental/Hero'))),
};

export const getComponentMapByTheme = (themeId: string, variant: string) => {
	if (themeId === 'teamTag' && variant !== 'default') {
		return teamTagComponents;
	}
	if (themeId === 'aspendental' && variant === 'AspenScheduler') {
		return AspenDentalComponents;
	}
	return componentMap;
};
